module.exports = __webpack_public_path__ + "static/media/like.d454f3f2.svg";